import eventNames from 'tracking/constants';
import {
  client,
  get,
  post,
  stringifyUrl,
} from './utils';
import {
  apiKeys,
  unenrollmentAction,
  enableEmailsAction,
} from './constants';
import urls from './urls';
import * as module from './api';

/*********************************************************************************
 * GET Actions
 *********************************************************************************/

// Competency-backing courses are auto-created by Blend-ed's Hasura
// CompetencyCourseCreation trigger and always have courseNumber === 'library'
// (key shape: course-v1:{org}+library+{competency_uuid}). They must never
// surface on the learner dashboard.
const isCompetencyBackingCourse = (course) => {
  const courseNumber = course?.course?.courseNumber;
  if (courseNumber === 'library') { return true; }
  const courseId = course?.courseRun?.courseId;
  return typeof courseId === 'string' && /^course-v1:[^+]+\+library\+/.test(courseId);
};

const stripCompetencyBackingCourses = (response) => {
  const data = response?.data;
  if (!data || !Array.isArray(data.courses)) { return response; }
  const filtered = data.courses.filter((c) => !isCompetencyBackingCourse(c));
  if (filtered.length === data.courses.length) { return response; }
  return { ...response, data: { ...data, courses: filtered } };
};

export const initializeList = ({ user } = {}) => get(
  stringifyUrl(urls.getInitApiUrl(), { [apiKeys.user]: user }),
).then(stripCompetencyBackingCourses);

export const updateEntitlementEnrollment = ({ uuid, courseId }) => post(
  urls.entitlementEnrollment(uuid),
  { [apiKeys.courseRunId]: courseId },
);

export const deleteEntitlementEnrollment = ({ uuid, isRefundable }) => client()
  .delete(
    stringifyUrl(
      urls.entitlementEnrollment(uuid),
      { [apiKeys.isRefund]: isRefundable },
    ),
  );

export const updateEmailSettings = ({ courseId, enable }) => post(
  urls.updateEmailSettings(),
  { [apiKeys.courseId]: courseId, ...(enable && enableEmailsAction) },
);

export const unenrollFromCourse = ({ courseId }) => post(
  urls.courseUnenroll(),
  { [apiKeys.courseId]: courseId, ...unenrollmentAction },
);

export const logEvent = ({ eventName, data, courseId }) => post(urls.event(), {
  courserun_key: courseId,
  event_type: eventName,
  page: window.location.href,
  event: JSON.stringify(data),
});

export const logShare = ({ courseId, site }) => module.logEvent({
  eventName: eventNames.shareClicked,
  courseId,
  data: {
    course_id: courseId,
    social_media_site: site,
    location: 'dashboard',
  },
});

export const createCreditRequest = ({ providerId, courseId, username }) => post(
  urls.creditRequestUrl(providerId),
  { course_key: courseId, username },
);

export default {
  initializeList,
  unenrollFromCourse,
  updateEmailSettings,
  updateEntitlementEnrollment,
  deleteEntitlementEnrollment,
  logEvent,
  logShare,
  createCreditRequest,
};
